"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _layout = _interopRequireDefault(require("@/layout"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; } /** When your routing table is too long, you can split it into small modules **/
var userAuthRouter = {
  path: '/basic',
  component: _layout.default,
  redirect: '/basic/gradeInfo',
  name: 'jurisdiction',
  alwaysShow: true,
  meta: {
    title: 'Basic',
    icon: 'basic'
  },
  children: [{
    path: 'grade',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/basic/gradeInfo'));
      });
    },
    name: 'userIndex',
    meta: {
      title: 'GradeList',
      icon: ''
    }
  }, {
    path: 'upgrade',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/basic/upgradeStrategy'));
      });
    },
    name: 'upgrade',
    meta: {
      title: 'upgradeStrategyPage',
      icon: ''
    }
  }, {
    path: 'activityOne',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/basic/activityOne'));
      });
    },
    name: 'activityOne',
    meta: {
      title: 'activityOne',
      icon: ''
    }
  }, {
    path: 'notice',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/basic/notice'));
      });
    },
    name: 'notice',
    meta: {
      title: '公告管理',
      icon: ''
    }
  }, {
    path: 'diamond',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/basic/diamond'));
      });
    },
    name: 'diamond',
    meta: {
      title: '钻石卡申请',
      icon: ''
    }
  }, {
    path: 'payPopup',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/activity/payPopup/index.vue'));
      });
    },
    name: 'PayPopup',
    meta: {
      title: '支付弹窗',
      icon: ''
    }
  }]
};
var _default = exports.default = userAuthRouter;